import type { WorkoutAttribution } from '@ergshoot/shared';
import { create } from 'zustand';

export interface MinimizedWorkout {
  id: string;
  name: string;
  description?: string | null;
  movements?: string[];
  scoring_type?: string;
  scoring_direction?: string;
  equipment?: string[];
  scheduled_date?: string;
  category?: string | null;
  coach_notes?: string | null;
  duration_minutes?: number | null;
  instructions?: string | null;
  created_by_name?: string | null;
  created_by_username?: string | null;
  created_at?: string | null;
  attribution?: WorkoutAttribution | null;
}

interface MinimizedWorkoutState {
  workout: MinimizedWorkout | null;
  minimize: (workout: MinimizedWorkout) => void;
  clear: () => void;
}

export const useMinimizedWorkoutStore = create<MinimizedWorkoutState>((set) => ({
  workout: null,
  minimize: (workout) => set({ workout }),
  clear: () => set({ workout: null }),
}));
